module.exports = __webpack_public_path__ + "img/5.3e6f1a5e.jpg";